import * as m from 'motion/react-m';
import {
	type ComponentProps,
	type ElementRef,
	type MouseEvent,
	useRef,
	useState,
} from 'react';
import { MotionProvider } from './motion';

export function MagnetMotion({ ...props }: ComponentProps<typeof m.div>) {
	const ref = useRef<ElementRef<typeof m.div>>(null);
	const [position, setPosition] = useState({ x: 0, y: 0 });

	const handleMouse = (e: MouseEvent<HTMLDivElement>) => {
		const { clientX, clientY } = e;
		const rect = ref.current?.getBoundingClientRect();
		if (!rect) return;
		setPosition({
			x: clientX - (rect.left + rect.width / 2),
			y: clientY - (rect.top + rect.height / 2),
		});
	};

	return (
		<MotionProvider>
			<m.div
				{...props}
				ref={ref}
				animate={position}
				style={{ position: 'relative' }}
				transition={{ type: 'spring', stiffness: 150, damping: 15, mass: 0.1 }}
				onMouseLeave={() => setPosition({ x: 0, y: 0 })}
				onMouseMove={handleMouse}
			/>
		</MotionProvider>
	);
}
